module.exports = __webpack_public_path__ + "static/media/Philomel.16ee9322.md";